/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown> }} Footer_CopyrightInputs */

const en_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const es_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const de_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const zh_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const ar_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const fr_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const vi_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const sw_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const th_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const bs_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const ja_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const ko_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const pt_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const it_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const sv_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const nl_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const da_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const nb_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const fi_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const pl_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const ru_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const tr_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const hi_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const id_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const ms_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const cs_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const el_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const he_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const af_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

const hu_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Mark Egly Golf`)
};

/**
* | output |
* | --- |
* | "© {year} Mark Egly Golf" |
*
* @param {Footer_CopyrightInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const footer_copyright = /** @type {((inputs: Footer_CopyrightInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_CopyrightInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_copyright(inputs)
	if (locale === "de") return de_footer_copyright(inputs)
	if (locale === "zh") return zh_footer_copyright(inputs)
	if (locale === "ar") return ar_footer_copyright(inputs)
	if (locale === "fr") return fr_footer_copyright(inputs)
	if (locale === "vi") return vi_footer_copyright(inputs)
	if (locale === "sw") return sw_footer_copyright(inputs)
	if (locale === "th") return th_footer_copyright(inputs)
	if (locale === "bs") return bs_footer_copyright(inputs)
	if (locale === "ja") return ja_footer_copyright(inputs)
	if (locale === "ko") return ko_footer_copyright(inputs)
	if (locale === "pt") return pt_footer_copyright(inputs)
	if (locale === "it") return it_footer_copyright(inputs)
	if (locale === "sv") return sv_footer_copyright(inputs)
	if (locale === "nl") return nl_footer_copyright(inputs)
	if (locale === "da") return da_footer_copyright(inputs)
	if (locale === "nb") return nb_footer_copyright(inputs)
	if (locale === "fi") return fi_footer_copyright(inputs)
	if (locale === "pl") return pl_footer_copyright(inputs)
	if (locale === "ru") return ru_footer_copyright(inputs)
	if (locale === "tr") return tr_footer_copyright(inputs)
	if (locale === "hi") return hi_footer_copyright(inputs)
	if (locale === "id") return id_footer_copyright(inputs)
	if (locale === "ms") return ms_footer_copyright(inputs)
	if (locale === "cs") return cs_footer_copyright(inputs)
	if (locale === "el") return el_footer_copyright(inputs)
	if (locale === "he") return he_footer_copyright(inputs)
	if (locale === "af") return af_footer_copyright(inputs)
	if (locale === "hu") return hu_footer_copyright(inputs)
	return en_footer_copyright(inputs)
});